import { Controller } from "@hotwired/stimulus";

// Onboarding wizard, full-page sequence after sign-up.
// This controller is intentionally minimal : la navigation entre étapes se
// fait par form submit standard (Turbo redirect côté serveur après un
// auto-save). Ici on ne gère que la modale "Compléter plus tard" + un peu
// de polish (Enter pour soumettre, Esc pour fermer la modale).
export default class extends Controller {
  static targets = ["skipModal", "skipBtn", "form"];
  static values = { skipUrl: String, step: String };

  connect() {
    this._onKey = this._handleKey.bind(this);
    document.addEventListener("keydown", this._onKey);
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey);
  }

  openSkipModal(event) {
    event?.preventDefault();
    if (!this.hasSkipModalTarget) return;
    this.skipModalTarget.hidden = false;
    requestAnimationFrame(() => {
      this.skipModalTarget.classList.add("ob-skip-modal--visible");
    });
    document.body.classList.add("ob-no-scroll");
  }

  closeSkipModal(event) {
    event?.preventDefault();
    if (!this.hasSkipModalTarget) return;
    this.skipModalTarget.classList.remove("ob-skip-modal--visible");
    document.body.classList.remove("ob-no-scroll");
    setTimeout(() => {
      if (this.hasSkipModalTarget) this.skipModalTarget.hidden = true;
    }, 200);
  }

  backdropClick(event) {
    // Close only when clicking the overlay (not the dialog inside it).
    if (event.target === this.skipModalTarget) {
      this.closeSkipModal(event);
    }
  }

  _handleKey(event) {
    if (event.key === "Escape" && this.hasSkipModalTarget && !this.skipModalTarget.hidden) {
      this.closeSkipModal();
    }
  }
}
